var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.734,
    viewBox: "0 0 20 19.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ambulatory_clinic",
    d: "M13.123,6a3.289,3.289,0,0,1,3.1,2.183H26V9.562l-2.466,1.661V24.63h1.644a.548.548,0,0,1,0,1.1H23.534v.008H8.192v-.008H6.548a.548.548,0,0,1,0-1.1H8.192V11.2L6,9.543V8.183h4.026A3.289,3.289,0,0,1,13.123,6Zm.548,2.74v-1.1h-1.1v1.1h-1.1v1.1h1.1v1.1h1.1v-1.1h1.1V8.74Zm7.671,7.123V24.63H16.959V15.863Zm-7.123,0H10.384V19.7h3.836Z",
    transform: "translate(-6 -6)",
    fill: "#9c8eeb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalIcon);
export default __webpack_public_path__ + "static/media/hospital-icon.24eb27a7c0425696660d80c2a14a941f.svg";
export { ForwardRef as ReactComponent };